var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Access","items":_vm.access_items,"value":_vm.value},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }